export default {
    formSave: 'Lagre',
    formBack: 'Tilbake',
    formNext: 'Neste',
    formCancel: 'Avbryt',
    formSkip: 'Hopp over',
    formClose: 'Lukk',
    formBackToCards: 'Tilbake til kortoversikt',
    formYesOrder: 'Ja, bestill',
    formYesOpen: 'Ja, åpne',
    formOk: 'Ok',
    formConfirm: 'Bekreft',
    formBackToAccountOverview: 'Tilbake til kontooversikten',
    formYes: 'Ja',
    formNo: 'Nei',
    formPleaseFillOutAlternative: 'Du må velge et alternativ',
    formPleaseFillOutForm: 'Vennligst fullfør skjemaet',
};
